import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateWaitingAreaLocalAccessHours } from '../../../../actions/waitingArea';
import { updateShowUpdateWaitingAreaLocalAccessHoursModal } from '../../../../actions/modal';
import { clone } from '../../../../reducers/helper.js';
import { verifyIfDaySelectionCorrect } from '../../../../businessLogic/operatingDaysAndHours';

export default function RightPanelUpdate(props) {
  const dispatch = useDispatch();
  const [isWaitingAreaUpdating, setIsWaitingAreaUpdating] = useState(false);

  const localAccessHoursUpdate = (e) => {
    if (
      !verifyIfDaySelectionCorrect(props.waitingAreaLocalAccessHoursForm.serviceOfferingAvailabilities) &&
      props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
    ) {
      return;
    }
    let cb = (result, f) => {
      setIsWaitingAreaUpdating(false);
      if (result) resetForm();
    };
    setIsWaitingAreaUpdating(true);
    dispatch(
      updateWaitingAreaLocalAccessHours(
        props.waitingArea.id,
        removeEmptyOperationalHours(props.waitingAreaLocalAccessHoursForm),
        cb
      )
    );
  };

  const removeEmptyOperationalHours = (waitingAreaLocalAccessHoursForm) => {
    //Removes the empty days instance if checkbox is checked for availability
    //if checkbox is unchecked we just remove the array;
    let localAccessHours = clone(waitingAreaLocalAccessHoursForm);

    if (props.waitingAreaLocalAccessHoursForm.limitedByLocalTime) {
      let correctLocalAccessHours = localAccessHours.serviceOfferingAvailabilities.filter((x) => {
        return (
          x.isMondaySelected ||
          x.isTuesdaySelected ||
          x.isWednesdaySelected ||
          x.isThursdaySelected ||
          x.isFridaySelected ||
          x.isSaturdaySelected ||
          x.isSundaySelected
        );
      });
      localAccessHours.serviceOfferingAvailabilities = correctLocalAccessHours;
    } else {
      localAccessHours.serviceOfferingAvailabilities = [];
    }
    return localAccessHours;
  };

  const cancelUpdateLocalAccessHours = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    dispatch(updateShowUpdateWaitingAreaLocalAccessHoursModal(false));
  };

  let saveClasses =
    'ui labeled icon button icon color-button color-button-hover color-white max-width left-text mrlnull mrbnull';
  if (
    !verifyIfDaySelectionCorrect(props.waitingAreaLocalAccessHoursForm.serviceOfferingAvailabilities) &&
    props.waitingAreaLocalAccessHoursForm.limitedByLocalTime
  ) {
    saveClasses += ' disable ';
  }
  return (
    <div>
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="4"
          type="button"
          onClick={localAccessHoursUpdate}
          className={isWaitingAreaUpdating ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark  icon" />
        </button>
        <button
          tabIndex="5"
          type="button"
          onClick={cancelUpdateLocalAccessHours}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    </div>
  );
}
